import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { auditLogKeys } from './auditLogKeys';
import type { AuditLogFilters } from '@aegislab/shared';
import { fetchAuditLogs, fetchAllAuditLogs } from '../api/auditLogApi';

/** 화면 조회에 쓰는 필터 축 — search·action 은 기존 positional 인자로 받는다. */
export type AuditLogViewFilters = Pick<AuditLogFilters, 'userId' | 'startDate' | 'endDate'>;

// X3 단계 1b (D4·D6): attendance audit read hooks.
// query key namespacing: ['attendance-audit', <scope>, ...args].
// 호출자 갱신은 단계 1d.

export function useAuditLogs(attendanceId: string | undefined) {
  return useQuery({
    queryKey: auditLogKeys.single(attendanceId),
    queryFn: () => fetchAuditLogs(attendanceId as string),
    enabled: !!attendanceId,
  });
}

export function useAllAuditLogs(
  limit = 100,
  offset = 0,
  search?: string,
  action?: string,
  filters: AuditLogViewFilters = {},
  options: { enabled?: boolean } = {}
) {
  const { userId, startDate, endDate } = filters;
  return useQuery({
    // 드릴다운처럼 대상이 정해져야 의미가 있는 호출은 게이팅한다 — 안 그러면 대상 없이
    // 전사 목록을 먼저 받아 캐시에 남기고, keepPreviousData 가 그것을 첫 선택 직원의
    // 이력으로 돌려준다 (형제 훅 useUserAttendances 의 enabled: !!userId 와 같은 처방).
    enabled: options.enabled ?? true,
    queryKey: auditLogKeys.list(limit, offset, search, action, { userId, startDate, endDate }),
    queryFn: () => fetchAllAuditLogs(limit, offset, search, action, filters),
    // 페이지 전환·검색·필터 변경 시 직전 페이지 데이터를 유지해 스켈레톤 깜빡임 대신
    // dim(refetch) 표시로 전환 — pagination 신뢰도 + a11y(aria-busy) 개선.
    placeholderData: keepPreviousData,
  });
}
